import { useState } from "react";
import ImageComponent from "../../components/Layouts/ImageComponent";
import ProviderComponent from "../../components/Layouts/ProviderComponent";
import ProviderDescriptionModal from "../../components/modal/ProviderDescriptionModal";
import { useNavigate } from "react-router-dom";

const VideoCard = (props) => {

    const {
        isProviderListing,
        renderPremiumTag,
        redirectToPage,
        providerId,
        isSearch,
        isSlider,
        index,
        m
    } = props

    let navigate = useNavigate();

    const [confirmModal, setConfirmModal] = useState(false)

    const encodedText = new DOMParser().parseFromString(m?.product_name, 'text/html').body.textContent;
    return (
        <>
            {
                isSlider ?
                    <div key={'single-' + index} className="boxslidersp">
                        <div className="broker-box">
                            <div className={`img-box_nw ${m.is_recurring ? 'position-relative' : ""}`}>
                                {
                                    m.is_recurring ?
                                        <div className="combo-tag">
                                            Subscription
                                        </div>
                                        : ""
                                }
                                <div className="img-videosec learn_image-card" onClick={() => {
                                            if(( !m.is_paid || m.showBuy))
                                            navigate(providerId ? `/shopping/${m?.product_id}?addToCart=${m?.is_addtocart}&source=services&provider_id=${providerId}`:  m?.product_type === "service" ? `/shopping/${m?.product_id}?addToCart=${m?.is_addtocart}&source=services` : `/shopping/${m?.product_id}?addToCart=${m?.is_addtocart}&source=videos`);
                                            else if (isProviderListing) 
                                                setConfirmModal(true)
                                             else 
                                                redirectToPage(m)
                                        }
                                                                }>

                                    <div className='img-box-video' >

                                        <ImageComponent
                                            thumbnail={m.product_thumbnail ? m.product_thumbnail : ""}
                                            name={m.product_name}
                                            errorClass="d-flex align-items-center justify-content-center bg-grey img-error img-videosec bk-grey"
                                            cssClass="img-videosec learn_image-card cursor pointer"
                                        />
                                        <div className="playbtnvideo">
                                            {m?.product_type==="service" ? "" :
                                                <svg xmlns="http://www.w3.org/2000/svg" width="48" height="48" viewBox="0 0 48 48">
                                                    <g id="Group_5737" data-name="Group 5737" transform="translate(-251 -1026)">
                                                        <g id="Group_2568" data-name="Group 2568" transform="translate(7.795 7.795)">
                                                            <g id="Ellipse_200" data-name="Ellipse 200" transform="translate(243.205 1018.205)" fill="#febe10" stroke="#fff" strokeWidth="4">
                                                                <circle cx="24" cy="24" r="24" stroke="none" />
                                                                <circle cx="24" cy="24" r="22" fill="none" />
                                                            </g>
                                                        </g>
                                                        <path id="Polygon_3" data-name="Polygon 3" d="M10,0,20,14H0Z" transform="translate(284 1040) rotate(90)" fill="#415385" />
                                                    </g>
                                                </svg>}
                                        </div>
                                    </div>
                                </div>
                                <div className="details-card_RP">
                                    <h5
                                        className="cursor-pointer"
                                        title={encodedText}
                                        dangerouslySetInnerHTML={{
                                            __html: m?.product_name
                                        }}
                                        onClick={() => {
                                            if(( !m.is_paid || m.showBuy))
                                            navigate(providerId ? `/shopping/${m?.product_id}?addToCart=${m?.is_addtocart}&source=services&provider_id=${providerId}`:   m?.product_type === "service" ? `/shopping/${m?.product_id}?addToCart=${m?.is_addtocart}&source=services` : `/shopping/${m?.product_id}?addToCart=${m?.is_addtocart}&source=videos`);
                                            else if (isProviderListing) 
                                                setConfirmModal(true)
                                             else 
                                                redirectToPage(m)
                                        }
                                        }
                                    ></h5>
                                    {m?.product_type==="service" ? <div className="discription-caouching">{m?.summary}</div> : "" } 
                                    <div className="row info-bottm-card_nw">
                                        <div className="col-md-12 d-flex justify-content-between vidocounspace">

                                            {
                                                isProviderListing ? "" :
                                                    <>
                                                        <div className="ico__imG01 d-flex">
                                                            <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16"><path id="clock-time-four" d="M10,2a8,8,0,1,0,8,8,8.024,8.024,0,0,0-8-8m3.44,10.56L9.2,10.24V6h1.2V9.52l3.6,2Z" transform="translate(-2 -2)" fill="#415385"></path></svg>
                                                            <span className="videoviews"><span className="videocount">{m?.course_duration}</span>&nbsp;{m?.durationUnit}</span>
                                                        </div>
                                                        <div className="ico_texxt02 d-flex">
                                                            <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16"><path id="eye-circle" d="M10,8a2,2,0,1,0,2,2,2,2,0,0,0-2-2m0,2.8a.8.8,0,1,1,.8-.8.8.8,0,0,1-.8.8M10,8a2,2,0,1,0,2,2,2,2,0,0,0-2-2m0,2.8a.8.8,0,1,1,.8-.8.8.8,0,0,1-.8.8M10,2a8,8,0,1,0,8,8,8,8,0,0,0-8-8m0,11.2A5.178,5.178,0,0,1,5.2,10a5.2,5.2,0,0,1,9.6,0A5.178,5.178,0,0,1,10,13.2M10,8a2,2,0,1,0,2,2,2,2,0,0,0-2-2m0,2.8a.8.8,0,1,1,.8-.8A.8.8,0,0,1,10,10.8Z" transform="translate(-2 -2)" fill="#415385"></path></svg>
                                                            <span className="videoviews"><span className="videocount">{m?.views}</span> View{m?.views > 1 ? "s" : ""}</span>
                                                        </div>
                                                    </>
                                            }
                                        </div>
                                    </div>
                                    <div className="event_learn">
                                        <div className="row infoIcon_nw">
                                            <div className="col-md-12 d-flex justify-content-between align-items-center action_learning02 action_learning">

                                                <ProviderComponent providerData={m.provider} />

                                                <div className="d-flex justify-content-between revisit_icon buTN_buy">
                                                    <div className="calendar_event">
                                                        {
                                                            (m.source != 'xsel' ||
                                                                m.is_paid ||
                                                                !m.showBuy) ? m?.product_type === "service" ? 
                                                                <button type="button" className="btn btn-primary-LR  setup-button"
                                                                onClick={() => {
                                                                    if (isProviderListing) {
                                                                        setConfirmModal(true)
                                                                    } else {
                                                                        redirectToPage(m)
                                                                    }
                                                                }}
                                                            >View More</button>:
                                                                <button type="button" className="btn btn-primary-LR  setup-button"
                                                                    onClick={() => {
                                                                        if (isProviderListing) {
                                                                            setConfirmModal(true)
                                                                        } else {
                                                                            redirectToPage(m)
                                                                        }
                                                                    }}
                                                                >View</button>
                                                                :
                                                                renderPremiumTag(m)

                                                        }
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    :
                    <div className={`col-md-6 col-lg-4 ${isSearch === true || window.location.pathname.includes("my-videos") ? "col-xl-3" : "col-xl-4"} col-12 videobox search__input`} key={'single-' + index}>
                        <div className={`img-box_RP ${m.is_recurring ? 'position-relative' : ''}`}>
                            {
                                m.is_recurring ?
                                    <div className="combo-tag">
                                        Subscription
                                    </div>
                                    : ""
                            }
                            <div className="img-videosec learn_image-card" onClick={() => {
                                            if(( !m.is_paid || m.showBuy))
                                            navigate(providerId ? `/shopping/${m?.product_id}?addToCart=${m?.is_addtocart}&source=services&provider_id=${providerId}`:   m?.product_type === "service" ? `/shopping/${m?.product_id}?addToCart=${m?.is_addtocart}&source=services` : `/shopping/${m?.product_id}?addToCart=${m?.is_addtocart}&source=videos`);
                                            else if (isProviderListing) 
                                                setConfirmModal(true)
                                             else 
                                                redirectToPage(m)
                                        }}>

                                <div className='img-box-video' >

                                    <ImageComponent
                                        thumbnail={m.product_thumbnail ? m.product_thumbnail : ""}
                                        name={m.product_name}
                                        errorClass="d-flex align-items-center justify-content-center bg-grey img-error img-videosec bk-grey"
                                        cssClass="img-videosec learn_image-card cursor pointer"
                                    />
                                    <div className="playbtnvideo">
                                        {m?.product_type==="service" ? "" :
                                            <svg xmlns="http://www.w3.org/2000/svg" width="48" height="48" viewBox="0 0 48 48">
                                                <g id="Group_5737" data-name="Group 5737" transform="translate(-251 -1026)">
                                                    <g id="Group_2568" data-name="Group 2568" transform="translate(7.795 7.795)">
                                                        <g id="Ellipse_200" data-name="Ellipse 200" transform="translate(243.205 1018.205)" fill="#febe10" stroke="#fff" strokeWidth="4">
                                                            <circle cx="24" cy="24" r="24" stroke="none" />
                                                            <circle cx="24" cy="24" r="22" fill="none" />
                                                        </g>
                                                    </g>
                                                    <path id="Polygon_3" data-name="Polygon 3" d="M10,0,20,14H0Z" transform="translate(284 1040) rotate(90)" fill="#415385" />
                                                </g>
                                            </svg>}
                                    </div>
                                </div>
                            </div>
                            <div className="details-card_RP">
                                <h5
                                    className="cursor-pointer"
                                    title={encodedText}
                                    dangerouslySetInnerHTML={{
                                        __html: m?.product_name
                                    }}
                                    onClick={() => {
                                        if(( !m.is_paid || m.showBuy))
                                        navigate(providerId ? `/shopping/${m?.product_id}?addToCart=${m?.is_addtocart}&source=services&provider_id=${providerId}`:   m?.product_type === "service" ? `/shopping/${m?.product_id}?addToCart=${m?.is_addtocart}&source=services` : `/shopping/${m?.product_id}?addToCart=${m?.is_addtocart}&source=videos`);
                                        else if (isProviderListing)
                                            setConfirmModal(true) 
                                        else 
                                            redirectToPage(m)
                                    }
                                    }
                                ></h5>
                               {m?.product_type==="service" ? <div className="discription-caouching">{m?.summary}</div> : "" } 
                                <div className="row info-bottm-card_nw">
                                    <div className="col-md-12 d-flex justify-content-between vidocounspace">
                                        {
                                            isProviderListing ? "" :
                                                <>
                                                    <div className="ico__imG01 d-flex">
                                                        <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16"><path id="clock-time-four" d="M10,2a8,8,0,1,0,8,8,8.024,8.024,0,0,0-8-8m3.44,10.56L9.2,10.24V6h1.2V9.52l3.6,2Z" transform="translate(-2 -2)" fill="#415385"></path></svg>
                                                        <span className="videoviews"><span className="videocount">{m?.course_duration}</span>&nbsp;{m?.durationUnit}</span>
                                                    </div>
                                                    <div className="ico_texxt02 d-flex">
                                                        <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" 
                                                        viewBox="0 0 16 16"><path id="eye-circle" d="M10,8a2,2,0,1,0,2,2,2,2,0,0,0-2-2m0,2.8a.8.8,0,1,1,.8-.8.8.8,0,0,1-.8.8M10,8a2,2,0,1,0,2,2,2,2,0,0,0-2-2m0,2.8a.8.8,0,1,1,.8-.8.8.8,0,0,1-.8.8M10,2a8,8,0,1,0,8,8,8,8,0,0,0-8-8m0,11.2A5.178,5.178,0,0,1,5.2,10a5.2,5.2,0,0,1,9.6,0A5.178,5.178,0,0,1,10,13.2M10,8a2,2,0,1,0,2,2,2,2,0,0,0-2-2m0,2.8a.8.8,0,1,1,.8-.8A.8.8,0,0,1,10,10.8Z" transform="translate(-2 -2)" fill="#415385"></path></svg> 
                                                        <span className="videoviews"><span className="videocount">{m?.views}</span> 
                                                        View{m?.views > 1 ? "s" : ""}</span>
                                                    </div>
                                                </>
                                        }
                                    </div>
                                </div>
                                <div className="event_learn">
                                    <div className="row infoIcon_nw">
                                        <div className="col-md-12 d-flex justify-content-between align-items-center action_learning02 action_learning">

                                            <ProviderComponent providerData={m.provider} />

                                            <div className="d-flex justify-content-between revisit_icon buTN_buy">
                                                <div className="calendar_event">
                                                    {
                                                        m?.product_type==="service" || providerId ? 
                                                        ((m.source != 'xsel' ||
                                                            m.is_paid) ? m?.product_type==="service" ? 
                                                            <button type="button" className="btn btn-primary-LR  setup-button"
                                                            onClick={() => {
                                                                if (isProviderListing) {
                                                                    setConfirmModal(true)
                                                                } else {
                                                                    redirectToPage(m)
                                                                }
                                                            }}
                                                        >View More</button>:
                                                            <button type="button" className="btn btn-primary-LR  setup-button"
                                                                onClick={() => {
                                                                    if (isProviderListing) {
                                                                        setConfirmModal(true)
                                                                    } else {
                                                                        redirectToPage(m)
                                                                    }
                                                                }}
                                                            >View</button>
                                                            :
                                                            renderPremiumTag(m)
                                                        ) : (
                                                            (m.source != 'xsel' ||
                                                                m.is_paid ||
                                                                !m.showBuy) ?
                                                                <button type="button" className="btn btn-primary-LR  setup-button"
                                                                    onClick={() => {
                                                                        if (isProviderListing) {
                                                                            setConfirmModal(true)
                                                                        } else {
                                                                            redirectToPage(m)
                                                                        }
                                                                    }}
                                                                >View</button>
                                                                :
                                                                renderPremiumTag(m)
                                                        )

                                                    }
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
            }
            <ProviderDescriptionModal 
                confirmModal={confirmModal}
                setConfirmModal={setConfirmModal}
                providerData={m}
            />
        </>
    )
}

export default VideoCard;